import { Layers } from "lucide-react";
import { ICON_COMPONENTS } from "@/lib/iconChoices";
import RichText from "@/components/RichText";

// Repli affiché tant que l'API n'a pas encore répondu (blocks === undefined,
// voir Home.jsx) — identique au contenu d'origine. Une fois les données
// chargées, les blocs (Studio de thème > Sprint 4) prennent le relais, même
// vides (une boutique a pu délibérément retirer toutes les cartes).
const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { icon: "Globe", title: "Applications web", desc: "Front performants, back robustes, prêts à scaler." } },
  { id: "fallback-2", props: { icon: "Smartphone", title: "Applications mobiles", desc: "iOS & Android, natifs ou cross-platform." } },
  { id: "fallback-3", props: { icon: "Layers", title: "Plateformes SaaS", desc: "Multi-tenant, facturation, auth — clé en main." } },
  { id: "fallback-4", props: { icon: "Plug", title: "API & intégrations", desc: "Paiement, CRM, IA, infra cloud — connectés." } },
];

// Valeurs par défaut identiques au contenu d'origine — voir HeroSection
// pour l'explication du repli.
const DEFAULTS = {
  heading: "Quatre expertises,<br>un seul interlocuteur.",
  subheading: "De la première ligne de code au support post-lancement, on couvre tout le cycle produit.",
};

export default function ServicesSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const cards = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false);
  return (
    <section id="services" className="max-w-[1240px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <RichText
        as="h2"
        className="font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink"
        html={t.heading}
      />
      <RichText as="p" preserveParagraphs className="text-[17px] text-graphite mt-4 max-w-xl" html={t.subheading} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
        {cards.map((block, i) => {
          const Icon = ICON_COMPONENTS[block.props?.icon] || Layers;
          return (
            <div
              key={block.id}
              data-block-key={block.id}
              className="rounded-card border-control border-stone bg-white p-6 hover:shadow-card hover:-translate-y-0.5 transition-all animate-fade-up"
              style={{ animationDelay: `${i * 70}ms` }}
            >
              <div className="h-12 w-12 rounded-btn flex items-center justify-center mb-5" style={{ background: "linear-gradient(135deg,#635BFF,#38BDF8)" }}>
                <Icon className="h-6 w-6 text-white" strokeWidth={1.8} />
              </div>
              <RichText as="h3" className="font-display font-semibold text-[17px] text-ink" html={block.props?.title} />
              <p className="text-[14px] text-graphite mt-2 leading-relaxed">{block.props?.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
